import { notify } from 'react-notify-toast';

export default class NotificationsHandler {
  constructor () {
    this.show = notify.createShowQueue(250, 250);
    this.defaultTimeout = 1000;
  }

  showSuccess (message, timeout) {
    this.show(message, 'success', timeout || this.defaultTimeout);
  }

  showError (message = 'There was an error with that action, we are sorry for that.', timeout) {
    this.show(message, 'error', timeout || this.defaultTimeout);
  }
}



// WEBPACK FOOTER //
// ./src/utils/NotificationsHandler.js